import styled from "@emotion/styled";
import isPropValid from "@emotion/is-prop-valid";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { StarIcon } from "src/assets/icons";

export const RadioWrapper = styled.div<{
  disabled?: boolean;
  hovered?: boolean;
}>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 24px;

  &:hover {
    ${({ disabled }) => !disabled && `background-color: rgba(255, 251, 235, 1)`}
`;

export const StyledStarRadio = styled(RadioGroup.Item, {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && !["checked", "error", "disabled"].includes(prop),
})<{
  disabled?: boolean;
  checked?: boolean;
  error?: boolean;
}>`
  background: none;
  border: none;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  path {
    fill: ${({ checked }) =>
      checked ? "rgba(227, 192, 57, 1)" : "transparent"};
    stroke: ${({ checked }) => !checked && "rgba(174, 179, 187, 1)"};
    transition: fill 0.2s ease;
  }

  &:hover path {
    stroke: ${({ checked }) => !checked && "rgba(141, 112, 0, 1)"};
  }
`;

type CustomRadioProps = {
  disabled?: boolean;
  ariaLabel: string;
  selected: boolean;
  setSelected: (selected: boolean) => void;
  value?: string;
};

export default function CustomRadio({
  disabled,
  ariaLabel,
  selected,
  setSelected,
  value,
}: CustomRadioProps) {
  return (
    <RadioWrapper>
      <StyledStarRadio
        value={value ?? ""}
        aria-label={ariaLabel}
        disabled={disabled}
        checked={selected}
        onClick={() => setSelected(true)}
      >
        <StarIcon width="22" height="22" />
      </StyledStarRadio>
    </RadioWrapper>
  );
}
